"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useTimeoutValue(initialValue, finalValue, timeout) {
    const [value, setValue] = (0, react_1.useState)(initialValue);
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(() => {
            setValue(finalValue);
        }, timeout);
        return () => {
            clearTimeout(timer);
        };
    }, [finalValue, timeout]);
    return value;
}
exports.default = useTimeoutValue;
